<div class="regulatory-section">
    <!-- Footer Header - Only shown when opened in new tab -->
    <app-footer-header *ngIf="isStandalonePage"></app-footer-header>
    
    <!-- Background with floating shapes -->
    <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
        <div class="shape shape-5"></div>
    </div>

    <!-- Main content container -->
    <div class="regulatory-container">
        <!-- Header -->
        <div class="regulatory-header" @fadeInUp>
            <h1 class="main-title">Regulatory Information</h1>
        </div>

        <!-- Alternating Layout -->
        <div class="alternating-layout">
            <div class="regulatory-item" *ngFor="let option of regulatoryOptions; let i = index"
                [class.even]="i % 2 === 1" [class.odd]="i % 2 === 0" @slideInRight
                [style.animation-delay]="(i * 0.2) + 's'">

                <!-- Icon Section -->
                <div class="item-icon" [class.icon-left]="i % 2 === 0" [class.icon-right]="i % 2 === 1">
                    <div class="icon-container">
                        <!-- Insurance Policy Icon -->

                        <img src="../../../../../../assets/gifs/hh.gif" alt="Loading"
                            class="loading-gif" *ngIf="i === 0" width="60" height="60">

                        <!-- Office Building Icon -->
                         <img src="../../../../../../assets/gifs/Distance.gif" alt="Loading"
                            class="loading-gif" *ngIf="i === 1" width="60" height="60">

                        <!-- Family/People Icon -->
                          <img src="../../../../../../assets/gifs/Honest.gif" alt="Loading"
                            class="loading-gif" *ngIf="i === 2" width="50" height="50">

                        <!-- Registration/Checkmark Icon -->

                        <img src="../../../../../../assets/gifs/Register.gif" alt="Loading"
                            class="loading-gif" *ngIf="i === 3" width="60" height="60">


                        <!-- Document/Register Icon -->

                         <img src="../../../../../../assets/gifs/Tax.gif" alt="Loading"
                            class="loading-gif" *ngIf="i === 4" width="60" height="60">

                    </div>
                </div>

                <!-- Content Section -->
                <div class="item-content" [class.content-right]="i % 2 === 0" [class.content-left]="i % 2 === 1">
                    <div class="content-card">
                        <h3 class="item-title">{{ option.title }}</h3>
                        <p class="item-description">{{ option.description }}</p>

                        <!-- Special content for specific items -->
                        <div class="special-content" *ngIf="i === 1">
                            <div class="map-container" @fadeInUp>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2487.1234567890123!2d0.12345678901234567!3d51.12345678901234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTEsMTIzNDU2Nzg5MDEyMzQ!5e0!3m2!1sen!2suk!4v1234567890123"
                                    width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </div>

                        <div class="special-content" *ngIf="i === 2">
                            <div class="logo-container" @fadeInUp>
                                <img src="../../../../../../assets/gifs/onefam.png" alt="One Family Logo"
                                    class="company-logo">
                            </div>
                        </div>

                        <div class="special-content" *ngIf="i === 4">
                            <div class="link-container" @fadeInUp>
                                <a href="https://www.fca.org.uk/firms/systems-reporting/register" target="_blank"
                                    class="fca-link">
                                    <span>Visit FCA Register</span>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <!-- Bottom curve design -->
                        <div class="card-bottom-pattern">
                            <svg viewBox="0 0 1440 320" width="100%" height="80" preserveAspectRatio="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill="#0075C9" fill-opacity="1"
                                    d="M0,192L80,181.3C160,171,320,149,480,160C640,171,800,213,960,224C1120,235,1280,213,1360,202.7L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z">
                                </path>
                                <path fill="#66AEE0" fill-opacity="0.8"
                                    d="M0,256L80,240C160,224,320,192,480,170.7C640,149,800,139,960,149.3C1120,160,1280,192,1360,208L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z">
                                </path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>
<app-footer *ngIf="isStandalonePage"></app-footer>
